import { Injectable, Injector } from "@angular/core";
import { Subject } from "rxjs";
import { ModuleService } from "./ModuleService";

@Injectable({
  providedIn: 'root'
})

export class PinPadService extends ModuleService {
  //PinPad

  private connectionX = new Subject<boolean>();
  isConnected = this.connectionX.asObservable();

  private isKeyPadEnabled = new Subject<boolean>();
  getKeyPad = this.isKeyPadEnabled.asObservable();

  private slogs = new Subject<string>();
  getLogs = this.slogs.asObservable();

  setConnection(value: any) {
    this.connectionX.next(value);
  }

  setKeyPad(value: any) {
    this.isKeyPadEnabled.next(value);
  }

  setLogs(value: any) {
    this.slogs.next("\n" + value);
  }

  constructor(public injector: Injector) {
    super("PinPad", injector)
    this.logger.log('PinPad constructor')
  }

  public pinPad_Connect() {
    return this.callMethod("pinPad_Connect");
  }

  public pinPad_IsConnected() {
    return this.callMethod("pinPad_IsConnected");
  }
  public pinPad_Enable() {
    return this.setEnabledPinPad("pinPad_Enable", true);
  }
  public pinPad_Disable() {
    return this.setEnabledPinPad("pinPad_Enable", false);
  }
  public pinPad_Disconnect() {
    return this.callMethod("pinPad_Disconnect");
  }

  private setEnabledPinPad(method: string, isAccept: boolean) {
    return this.callMethod(method, isAccept)
  }

}
